import type { ValidationIssueFamily } from './validationIssueFamilies';
import { validationCopy } from '../copy/validationCopy';
import { formatCategory } from './validationFormatting';

export function buildIssueClipboardText(family: ValidationIssueFamily): string {
  return [
    family.title,
    '',
    `${validationCopy.detailPanel.clipboard.severity}: ${family.severity}`,
    `${validationCopy.detailPanel.clipboard.category}: ${formatCategory(family.category)}`,
    `${validationCopy.detailPanel.clipboard.target}: ${family.targetLabel}`,
    `${validationCopy.detailPanel.clipboard.affectedItems}: ${family.affectedItems.join(', ') || validationCopy.detailPanel.clipboard.noneListed}`,
    '',
    `${validationCopy.detailPanel.clipboard.examples}:`,
    ...family.examples.map((example) =>
      validationCopy.detailPanel.clipboard.exampleLine(example.label, example.detail)
    ),
  ].join('\n');
}
